export default {
    //检查参数是否完整
    checkParameter(json) {
        let parameter = {}
        let thematic = json.configcont.thematic
        if(thematic.serviceUrl){
            parameter.url = thematic.serviceUrl
            parameter.layerName = thematic.serviceLayer
            parameter.styleName = thematic.vtsConfig.style
            for (const values of Object.values(parameter)) {
                if (values === undefined) {
                    return false
                }
            }
            return parameter
        }
        return false

    },

    async initLayer(url, layerName, styleName) {
        let VTS = new GeoGlobe.Format.VTS();
        return VTS.createLayer(url, {layer: layerName, styleName: styleName})
    }
}
